function Tween(func, finishfunc) {
	this.func = func;
	this.finished = finishfunc;
	this.running = false;
	this.origin = {};
	this.destination = {};
	this.current = {};
	this.origin.x = 0;
	this.origin.y = 0;
	this.waits = 0;
};

Tween.prototype.easeInOutQuad = function (t, b, c, d) {
		t /= d/2;
		if (t < 1) return c/2*t*t + b;
		t--;
		return -c/2 * (t*(t-2) - 1) + b;
};

Tween.prototype.start = function(from, to, time, easing) {
	this.easing = easing;
	this.origin = from;
	this.current = from;
	this.time = time;
	this.destination = to;
	this.running = true;

	if (this.waits > 0) {
		var self = this;
		setTimeout(function() {
			self.sdt = Date.now();

			player.addProcess(self);

		}, this.waits);
	} else {
		this.sdt = Date.now();

		player.addProcess(this);
	}
};

Tween.prototype.wait = function(ms) {
	this.waits = ms;
	return this;
};

Tween.prototype.stop = function() {
	this.running = false;
};

Tween.prototype.isRunning = function() {
	return this.running;
};

Tween.prototype.process = function() {
	if (this.running) {
		var cd = Date.now();
		this.current = this.easeInOutQuad(cd - this.sdt, this.origin, this.destination - this.origin, this.time);

		this.func(this.current);

		if (cd - this.sdt > this.time) {
			this.func(this.destination);
			this.running = false;
			player.removeProcess(this);
			this.finished();
		}
	}
}
